(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-scripts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!window.Shopify) return;
    const shopId = window.shopId;
    const merchantName = window.merchantName;
    const shopUrl = window.shopUrl;
    const accessToken = window.accessToken;

    const buyerCountry = window.Shopify.country;
    const buyerLocale = window.Shopify.locale;
    const buyerCurrency = window.Shopify.currency ? window.Shopify.currency.active : null;
    const encodedOrigin = encodeURIComponent(shopUrl);
    const iframeSrc = `${shopUrl}/services/login_with_shop/authorize?target_origin=${encodedOrigin}&flow=shop_pay_button`;
    window.shopPaymentConfig = {
      shopId: shopId,
      merchantName: merchantName,
      accessToken: accessToken,
      buyerCountry: buyerCountry,
      buyerLocale: buyerLocale,
      buyerCurrency: buyerCurrency,
      iframeSrc: iframeSrc,
      recommendedConfig: {
        name: 'shop_pay',
        wallet_params: {
          shopId: shopId,
          merchantName: merchantName,
          personalized: true,
        },
      },
      fallbackConfig: {
        name: 'buy_it_now',
        wallet_params: {},
      },
      shopPayWalletParams: {
        shopId: shopId,
        merchantName: merchantName,
        personalized: true,
      },
    };
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-quick-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('GlobalQuickModal');
    const unlockBodyScroll = () => {
      const mainBody = document.body;
      const savedPosition = parseInt(mainBody.dataset.scrollPosition || '0');

      ['overflow', 'position', 'top', 'width'].forEach((prop) => mainBody.style.removeProperty(prop));
      //delete mainBody.dataset.scrollPosition;
      modal.classList.remove('modal--quick-view', 'modal--quick-add');
      window.scrollTo({ top: savedPosition, behavior: 'instant' });
    };
    if (modal) {
      modal.addEventListener('close', () => {
        const modalBody = modal.querySelector('.modal__body');
        const modalTitle = modal.querySelector('.modal__title');

        if (modalBody) modalBody.innerHTML = '';
        if (modalTitle) modalTitle.textContent = '';
        unlockBodyScroll();
      });
      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          modal.close();
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xgen-filters"] && !Shopify.designMode) return;
  try {
    window.addEventListener('DOMContentLoaded', () => {
    filterSection();
    filterSidePanel();
    initDescriptionToggle();
  });

  const filterSection = () => {
    const close_filters_element_id = 'close-btn';
    const see_results_element_id = 'see-results-btn';
    const component_id = 'xgen-filters-sidebar';
    const openClass = 'open-left';

    const isFiltersHidden = false;
    const isAllFiltersCollapsed = false;
    const isOneFilterOpen = false;

    const sidebarEl = document.querySelector(`.${component_id}`);
    if (!sidebarEl) return;

    const sidebarClass = sidebarEl.className;

    if (isFiltersHidden) {
      sidebarEl.className = sidebarClass.replace('open', '');
    }

    if (isAllFiltersCollapsed) {
      document.querySelectorAll('.xgen-filters-body').forEach((item) => {
        item.setAttribute('aria-expanded', 'false');
      });
    }

    if (isOneFilterOpen) {
      document.querySelectorAll('.xgen-filters-body').forEach((item, index) => {
        if (index > 0) item.setAttribute('aria-expanded', 'false');
      });
    }

    const toggleFilterSection = () => {
      const containerElement = document.getElementById(component_id);
      if (!containerElement) return;
      containerElement.classList.toggle(openClass);
      document.documentElement.classList.remove('xgen-no-scroll', 'xgen-no-scroll--drawer');
    };

    const closeFiltersElement = document.getElementById(close_filters_element_id);
    if (closeFiltersElement) {
      closeFiltersElement.addEventListener('click', toggleFilterSection);
    }

    const seeResultsElement = document.getElementById(see_results_element_id);
    if (seeResultsElement) {
      seeResultsElement.addEventListener('click', toggleFilterSection);
    }
  };

  const filterSidePanel = () => {
    const filter_toggle_sidepanel_element_id = 'filter-toggle-sidepanel';
    const filter_component_id = 'xgen-filters-sidebar';
    const openClass = 'open-left';

    const containerElement = document.getElementById(filter_component_id);
    if (!containerElement) return;

    const toggleFilterSection = () => {
      containerElement.classList.toggle(openClass);
      document.documentElement.classList.toggle('xgen-no-scroll');
      document.documentElement.classList.toggle('xgen-no-scroll--drawer');
    };

    const filterToggleSidepanelElement = document.getElementById(filter_toggle_sidepanel_element_id);
    if (filterToggleSidepanelElement) {
      filterToggleSidepanelElement.addEventListener('click', toggleFilterSection);
    }
    const mobileContainerClasses = ['xgen-modal', 'animated-left', 'left'];
    mobileContainerClasses.forEach((c) => containerElement.classList.add(c));
  };

  const initDescriptionToggle = () => {
    const description = document.querySelector('[data-xgen-description]');
    if (!description) return;

    const descriptionCopy = description.querySelector('[data-xgen-description-copy]');
    const toggle = description.querySelector('[data-xgen-description-toggle]');
    if (!descriptionCopy || !toggle) return;

    // Determine if description is truncated
    if (descriptionCopy.clientHeight === descriptionCopy.scrollHeight) {
      description.classList.remove('xgen-search-description--expanded');
    } else {
      description.classList.add('xgen-search-description--truncated');
    }

    description.classList.remove('xgen-search-description--init');

    const handleToggle = (e) => {
      e.preventDefault();
      description.classList.toggle('xgen-search-description--truncated');
      description.classList.toggle('xgen-search-description--expanded');
      //toggle.remove();
    };

    toggle.addEventListener('click', handleToggle);
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["xgen-sorting"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'xgen-ready',
    () => {
      const header = document.querySelector('.xgen-collection-header');
      if (!header) return;
      header.style.transition = 'opacity 0.3s ease-in-out';
      setTimeout(() => {
        header.style.opacity = '1';
      }, 100);
    },
    { once: true }
  );

  document.addEventListener('DOMContentLoaded', () => {
    const sortingBody = document.querySelector('#sorting-dropdown-body');
    const dropdownBtn = document.querySelector('#sorting-dropdown-btn');
    const sortingList = sortingBody?.querySelector('.xgen-sorting-list');
    const labelSpan = dropdownBtn?.querySelector('span');
    const openClass = 'open';

    if (!dropdownBtn || !sortingList || !labelSpan) return;

    const sortValueMap = {
      default: 'default',
      'price-asc': 'price__asc',
      'price-desc': 'price__desc',
      'update_date-desc': 'published_at__desc',
    };

    const updateURLParam = (param, value) => {
      const url = new URL(window.location.href);
      url.searchParams.set(param, value);
      history.replaceState({}, '', url);
    };

    const params = new URLSearchParams(window.location.search);
    const currentSort = params.get('filter_sort') || 'default';
    const options = sortingList.querySelectorAll('.xgen-sorting-option');
    if (!options.length) return;

    let activeOption = options[0];
    for (let i = 0; i < options.length; i++) {
      const opt = options[i];
      const key = opt.getAttribute('data-value');
      if (sortValueMap[key] === currentSort) {
        activeOption = opt;
        break;
      }
    }

    activeOption.classList.add('active');
    labelSpan.textContent = activeOption.textContent.trim();
    dropdownBtn.setAttribute('data-value', activeOption.getAttribute('data-value'));

    let outsideAbort = null;
    let outsideTimer = 0;
    const detachOutsideClick = () => {
      if (outsideTimer) {
        clearTimeout(outsideTimer);
        outsideTimer = 0;
      }
      outsideAbort?.abort();
      outsideAbort = null;
    };

    const attachOutsideClick = () => {
      detachOutsideClick();
      outsideAbort = new AbortController();
      const { signal } = outsideAbort;
      outsideTimer = setTimeout(() => {
        outsideTimer = 0;
        if (signal.aborted) return;
        document.addEventListener(
          'click',
          (ev) => {
            if (sortingBody.contains(ev.target) || ev.target === dropdownBtn) return;
            sortingBody.classList.remove(openClass);
            detachOutsideClick();
          },
          { signal, capture: true }
        );
      }, 100);
    };

    sortingList.addEventListener('click', (e) => {
      const opt = e.target.closest('.xgen-sorting-option');
      if (!opt || !sortingList.contains(opt)) return;
      e.stopPropagation();

      const prev = sortingList.querySelector('.xgen-sorting-option.active');
      if (prev && prev !== opt) prev.classList.remove('active');
      opt.classList.add('active');

      const dataValue = opt.getAttribute('data-value');
      labelSpan.textContent = opt.textContent.trim();
      dropdownBtn.setAttribute('data-value', dataValue);
      updateURLParam('filter_sort', sortValueMap[dataValue]);

      sortingBody.classList.remove(openClass);
      detachOutsideClick();
    });

    dropdownBtn.addEventListener('click', (e) => {
      e.stopImmediatePropagation();
      e.stopPropagation();
      sortingBody.classList.toggle(openClass);

      if (sortingBody.classList.contains(openClass)) {
        attachOutsideClick();
      } else {
        detachOutsideClick();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
